import FooterCompact from "./FooterCompact";
import Sidebar from "../Sidebar";

const DashboardLayout = ({ children }) => {
  return (
    <>
      <Sidebar />
      <main className="main-content" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          {children}
        </div>
        <FooterCompact />
      </main>
    </>
  );
};

export default DashboardLayout;
